import React, { useState } from "react";
import { Modal, Input, Button, message } from "antd";
import { useAdminHardDeleteTrip } from "../services/trip.service";

interface AdminHardDeleteTripModalProps {
    open: boolean;
    tripId: string;
    onClose: () => void;
    onDeleted: () => void;
}

const AdminHardDeleteTripModal: React.FC<AdminHardDeleteTripModalProps> = ({ open, tripId, onClose, onDeleted }) => {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const hardDeleteMutation = useAdminHardDeleteTrip({
        onSuccess: (response: any) => {
            if (response?.statusCode === 200 || response?.statusCode === 201) {
                message.success("Trip permanently deleted.");
                setPassword("");
                setError("");
                onDeleted();
            } else {
                setError(response?.statusMessage || "Could not delete this trip.");
            }
        },
        onError: (err: any) => {
            setError(err?.response?.statusMessage || "Could not delete this trip.");
        },
    });

    const handleConfirm = () => {
        if (!password) {
            setError("Please enter your password to confirm.");
            return;
        }
        setError("");
        hardDeleteMutation.mutate({ tripId, password });
    };

    const handleClose = () => {
        setPassword("");
        setError("");
        onClose();
    };

    return (
        <Modal
            title={<span className="custom-modal-title">Permanently Delete Trip</span>}
            open={open}
            onCancel={handleClose}
            maskClosable={false}
            footer={[
                <Button key="back" onClick={handleClose} className="hover:!text-black hover:!border-black">
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    danger
                    type="primary"
                    loading={hardDeleteMutation.isPending}
                    onClick={handleConfirm}
                >
                    Permanently Delete
                </Button>,
            ]}
        >
            <p className="mb-4">
                This permanently removes the trip and everything tied to it (schedules, payments, notifications).
                <b> This cannot be undone</b> -- unlike Cancel or the regular Delete, no record is kept for audit
                purposes. This is blocked if a schedule on this trip is currently Running.
            </p>
            <b className="block mb-2">Confirm your login password:</b>
            <Input.Password
                value={password}
                onChange={(e) => {
                    setPassword(e.target.value);
                    if (error) setError("");
                }}
                placeholder="Enter your password"
                onPressEnter={handleConfirm}
            />
            {error && (
                <p className="ant-form-item-explain-error text-red-500 mt-2 font-semibold">{error}</p>
            )}
        </Modal>
    );
};

export default AdminHardDeleteTripModal;
